// EventViewer.jsx
import React, { useEffect, useState } from "react";
import {
    Paper,
    Typography,
    List,
    ListItem,
    ListItemText,
    CircularProgress,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

const EventViewer = ({ gameId }) => {
    const dispatch = useDispatch();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);

    const gameEvents = useSelector((state) => state.teamgames.gameEvents);


    return (
        <Paper style={{ padding: 16, marginTop: 16 }}>
            <Typography variant="h6" gutterBottom>
                Eventos Registrados
            </Typography>
            {loading ? (
                <CircularProgress />
            ) : (
                <List dense>
                    {gameEvents && gameEvents.sort((a, b) => b.timestamp - a.timestamp).map((ev, index) => (
                        <ListItem key={index} divider>
                            <ListItemText
                                primary={`[${new Date(ev.timestamp).toLocaleTimeString()}] ${ev.tipo}`}
                                secondary={`Cuarto: ${ev.cuarto || "-"}, Jugador: ${ev.numero || "-"}, Equipo: ${ev.equipo || "-"}, Puntos: ${ev.cantidad || "-"}`}
                            />
                        </ListItem>
                    ))}
                </List>
            )}
        </Paper>
    );
};

export default EventViewer;
